import { httpClient } from '../http/httpClient'

export interface NewPasswordResponse {
  success: boolean
}

export interface NewPasswordParams {
  token: string
  password: string
}

export const newPassword = async (params: NewPasswordParams) => {
  const { data } = await httpClient.post<NewPasswordResponse>(
    '/auth/recovery-password',
    params,
  )
  return data
}
